<template>
  <div id="home">
    <div class="home-top">
      <div class="header">
        <div class="logo">
          <img v-if="isCode == true" :src="wxHeadImg" alt="头像" />
          <!-- <img v-else  src="./../../assets/xxtx.jpg" alt="头像"> -->
        </div>
        <div class="header-userInfo">
          <div>
            <p v-if="isCode == true">{{ wxNickName }}</p>
            <!-- <div><a style="line-height: 24px;color: #1989fa;font-weight: bold;font-size: 14px;" @click="logoutHandler()"> 退  出 </a></div> -->
          </div>

          <div class="iccid-line">
            <p>设备号：{{ this.$store.state.recordLoginText }}</p>
            <!-- 卡片管理按钮隐藏 -->
            <!-- <div >
              <van-icon name="descending" 
              size="18" color="rgb(25, 137, 250)"
              @click="showIccidList = true"/>
            </div> -->
            <!-- 卡片管理按钮隐藏 -->
          </div>

          <!-- <p v-if="simInfo.alias">{{ simInfo.supplierTypeName }}</p> -->
          <div class="u-flex">
            <!-- <div style="width: 50%">  {{ simInfo.supplierTypeName }} </div> -->
              <div style="width: 50%">型号： mifi-WX-MF1 </div>
            <div style=" width: 50%; text-align: right; display: flex;  align-items: center;  justify-content: flex-end;" >
              
              <div class="freshBtn" @click="getAccount()">
                <img src="@/assets/home/14.png" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flowInfo">
        <canvas id="home_progressBar" width="900" height="900"></canvas>
        <div class="residue-flow">
          <p style="font-size: 1rem; padding-bottom: 1rem">设备状态</p>
          <p style="font-size: 1.3rem; padding-bottom: 1rem">
            {{ simInfo.cardStateName }}
          </p>
        </div>
        <div class="flowInfo-bottom">
          <div v-if="isShowData" class="total-flow">
            <p>{{ fluxMtoG(simInfo.flowRate) }}</p>
            <p>设备流量/GB</p>
          </div>
          <div v-else class="total-flow">
            <span style="font-size: 21px">无限~</span>
            <p>总流量/GB</p>
          </div>
          <div class="used-flow">
            <p>{{ fluxMtoG(simInfo.usedFlowRate) }}</p>
            <p>已使用/GB</p>
          </div>
        </div>
      </div>
      <!-- <div class="yue" @click="toBalanceRecharge()">
        <span style="color:#FEB652;padding-right:10px;">赠送券</span> <span style="color:#FA0000;">￥{{(money_format(userAccount.amount / 100, 2, ".", ",") * 1) + tuiPrice * 1}}</span>
      </div> -->
    </div>

    <!-- 卡片管理 -->
    <van-popup
      v-model="showIccidList"
      closeable
      position="top"
      style="min-height: 20%; max-height: 50%"
    >
      <div class="iccid-list">
        <h1>卡片管理</h1>
        <div
          class="iccid-list-item"
          v-for="item in iccidList"
          :key="item.iccid"
        >
          <p v-if="item.simDefault == 0">{{ item.iccid }}</p>
          <p v-else-if="item.simDefault == 1" style="color: #ffa941">
            {{ item.iccid }}
          </p>
          <button v-if="item.simDefault == 0" @click="updateDefaultBindIccidHandler(item.iccid)"  > 设为默认 </button>
          <!-- <button class="delete-item" @click="deleteBindIccidHandler(item.iccid)">删除</button> -->
        </div>
      </div>
    </van-popup>
    <!-- 卡片管理 end -->

    <div class="main">
      <div class="content-top">
        <!--  总部微信公众号   -->
        <div class="main-top" v-if="$store.state.isHeadquarterAppid == 'true'">
          <div class="line first-line">
            <p class="packageName">
              <span v-if="simInfo.simPackageList[0]">套餐名称：{{ simInfo.packageName }}</span >
              <span v-else style="color: red">套餐名称：设备暂未订购套餐</span>
            </p>
            <p class="morePackage">
              <a href="javascript: void(0);" @click="pkgListVisible = true" >更 多</a >
            </p>

            <p class="time-line">设备有效期：{{ simInfo.endTime }}</p>
          </div>
          <van-divider  :style="{ color: '#1989fa', borderColor: '#1989fa', margin: '5px 0' }" />
          <van-notice-bar
            color="#1989fa"
            background="#fff"
            left-icon="volume-o"
            :text="notifyContent"
            :style="{ padding: '0' }"
            mode="link"
            @click="toMoreNotify()"
          ></van-notice-bar>
        </div>

        <!--  代理商微信公众号   -->
        <div class="main-top" v-else>
          <div class="line first-line">
            <p class="packageName">
              <span v-if="simInfo.simPackageList[0]">套餐名称：{{ simInfo.packageName }}</span>
              <span v-else style="color: red">套餐名称：暂未订购套餐</span>
            </p>
            <p class="morePackage">
              <a href="javascript: void(0);" @click="pkgListVisible = true">更 多</a >
            </p>
            <p class="p-sim">SIM：{{ simInfo.simId }}</p>
            <p class="time-line">套餐有效期：{{ simInfo.endTime }}</p>
          </div>
        </div>
      </div>

      <div class="content-bottom">
        <div class="main-bottom">
          <!-- 是否是设备专用通道 -->
          <div v-if="!isShowData">
            <div>
              <a href="javascript: void(0);" @click="toRecharge()">
                <img src="@/assets/home/17.png" alt="" />
                <div class="shadow"></div>
                <span>套餐订购</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="analysisHandler()">
                <img src="@/assets/home/11.png" alt="" />
                <div class="shadow"></div>
                <span>智能诊断</span>
              </a>
            </div>
          </div>
          <!--  总部微信公众号   -->
          <div v-else-if="$store.state.isHeadquarterAppid == 'true'">
            <div>
              <a href="javascript: void(0);" @click="toRecharge()">
                <img src="@/assets/home/17.png" alt="" />
                <div class="shadow"></div>
                <span>订购设备</span>
              </a>
            </div>

            <div v-if="simInfo.supplierTypeCode == 3">
              <a href="javascript: void(0);" @click="reloadSim()">
                <img src="@/assets/home/16.png" alt="" />
                <div class="shadow"></div>
                <span>刷新网络</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="toRecharge12()">
                <img src="@/assets/home/11.png" alt="" />
                <div class="shadow"></div>
                <span>设备复机</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="realNameRegister()">
                <img src="@/assets/home/18.png" alt="" />
                <div class="shadow"></div>
                <span>设备实名</span>
              </a>
            </div>

            <div>
              <a href="javascript: void(0);" @click="analysisHandler()">
                <img src="@/assets/home/11.png" alt="" />
                <div class="shadow"></div>
                <span>设备诊断</span>
              </a>
            </div>

            <div>
              <a href="#/user/balanceRechargeRecord">
                <img src="@/assets/home/19.png" alt="" />
                <div class="shadow"></div>
                <span>充值记录</span>
              </a>
            </div>
            <div v-if="alreadyHasAccount">
              <a href="javascript: void(0);" @click="showPasswordPanel = true">
                <img src="@/assets/home/22.png" alt="" />
                <div class="shadow"></div>
                <span>余额密码</span>
              </a>
            </div>

            <div v-if="canChangeCard">
              <a href="javascript:void(0)" @click="toChgCardQuery()">
                <img src="@/assets/home/15.png" alt="" />
                <div class="shadow"></div>
                <span>换卡申请</span>
              </a>
            </div>

            <!-- <div v-if="!haveRealName">
                <a href="javascript: void(0);"  @click="confirmMobile()">
                  <img src="@/assets/home/25.png" alt="">
                  <div class="shadow"></div>
                  <span>注销实名</span>
                </a>
              </div> -->

            <div v-if=" simInfo.supplierTypeCode == 1 || simInfo.supplierTypeCode == 5 " >
              <a href="javascript: void(0);" @click="reBind()">
                <img src="@/assets/home/24.png" alt="" />
                <div class="shadow"></div>
                <span>机卡重绑</span>
              </a>
            </div>
            <div  v-if=" simInfo.basePkgGroup != '1562613197939142656' &&  simInfo.basePkgGroup != '1565598068475162624' " >
              <a href="javascript: void(0);" @click="toBalanceRecharge()">
                <img src="@/assets/home/12.png" alt="" />
                <div class="shadow"></div>
                <span>余额充值</span>
              </a>
            </div>
            <div v-else>
              <a href="javascript: void(0);" @click="goQuan()">
                <img src="@/assets/home/12.png" alt="" />
                <div class="shadow"></div>
                <span>余额充值</span>
              </a>
            </div>
            <div v-if=" simInfo.iccid == '8888888888888866666' || simInfo.iccid == '8888888888888866668' " @click="toLuckHome()"  >
              <a href="javascript: void(0);">
                <img src="@/assets/home/26.png" alt="" />
                <div class="shadow"></div>
                <span>幸运大转盘</span>
              </a>
            </div>

           
            <!-- <div
              @click="toApplyShops()"
            >
              <a href="javascript: void(0);">
                <img src="@/assets/home/27.png" alt="" />
                <div class="shadow"></div>
                <span>赠送金</span>
              </a>
            </div>
             <div @click="toApplyShop()">
              <a href="javascript: void(0);">
                <img src="@/assets/home/20.png" alt="" />
                <div class="shadow"></div>
                <span>流量兑换卷</span>
              </a>
            </div>
            <div @click="toApplyTui()">
              <a href="javascript: void(0);">
                <img src="@/assets/home/27.png" alt="" />
                <div class="shadow"></div>
                <span>领取余额</span>
              </a>
            </div> -->
          </div>

          <!--  代理商端  -->
          <div v-else>
            <div>
              <a href="javascript: void(0);" @click="toRecharge()">
                <img src="@/assets/home/17.png" alt="" />
                <div class="shadow"></div>
                <span>套餐订购</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="toRecharge12()">
                <img src="@/assets/home/11.png" alt="" />
                <div class="shadow"></div>
                <span>一键复机</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="realNameRegister()">
                <img src="@/assets/home/18.png" alt="" />
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div>
              <a href="javascript: void(0);" @click="analysisHandler()">
                <img src="@/assets/home/11.png" alt="" />
                <div class="shadow"></div>
                <span>智能诊断</span>
              </a>
            </div>
            <div>
              <a href="javascript:void(0)" @click="toChgCardQuery()">
                <img src="@/assets/home/15.png" alt="" />
                <div class="shadow"></div>
                <span>换卡申请</span>
              </a>
            </div>

            <div>
              <a href="#/user/balanceRechargeRecord">
                <img src="@/assets/home/19.png" alt="" />
                <div class="shadow"></div>
                <span>充值记录</span>
              </a>
            </div>

            <div v-if="!haveRealName">
              <a href="javascript: void(0);" @click="confirmMobile()">
                <img src="@/assets/home/25.png" alt="" />
                <div class="shadow"></div>
                <span>注销实名</span>
              </a>
            </div>

            <div
              v-if="
                simInfo.supplierTypeCode == 1 || simInfo.supplierTypeCode == 5
              "
            >
              <a href="javascript: void(0);" @click="reBind()">
                <img src="@/assets/home/24.png" alt="" />
                <div class="shadow"></div>
                <span>机卡重绑</span>
              </a>
            </div>
          </div>
          <!--  代理商端 end -->
        </div>
        <!--  main-bottom” class   end  -->
      </div>
      <!--  “content-bottom” class   end  -->
    </div>
    <!--  “main” class   end  -->

    <p class="tip" v-if="showSupplierTip">
      部分用户如果充值后上不了网，请设置<br />APN：iotdunj.grevpdn.sd，重启便可
    </p>

    <!-- 修改密码框   -->
    <div
      class="van-overlay"
      style="z-index: 1999"
      v-show="showPasswordPanel"
    ></div>
    <div
      class="van-popup van-popup--round van-popup--center changePasswordPanel"
      style="z-index: 2000; min-height: 55%; min-width: 80%"
      v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }"
    >
      <van-icon
        name="cross"
        class="icon-cross"
        @click="cancelChangePassword()"
      />

      <!-- 原密码输入框 -->
      <p>原密码：</p>
      <van-password-input
        :value="oldPassword"
        :focused="oldPasswordKeyboard"
        @focus="oldPasswordOnfocus()"
      />
      <!-- 新密码输入框 -->
      <p>新密码：</p>
      <van-password-input
        :value="newPassword"
        :focused="newPasswordKeyboard"
        @focus="newPasswordOnfocus()"
      />
      <!-- 原密码输入框 -->
      <p>再次确认：</p>
      <van-password-input
        :value="confirmPassword"
        :focused="confirmPasswordKeyboard"
        @focus="confirmPasswordOnfocus()"
      />
      <div class="confirmChangePassword">
        <van-button
          class="confirmChangePasswordBtn"
          plain
          hairline
          type="info"
          @click="sureToChangePassword()"
          >确 定</van-button
        >
      </div>
    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard
      :z-index="2015"
      :show="oldPasswordKeyboard"
      @input="oldPasswordOnInput"
      @delete="oldPasswordOnDelete"
      @blur="oldPasswordKeyboard = false"
    />

    <van-number-keyboard
      :z-index="2015"
      :show="newPasswordKeyboard"
      @input="newPasswordOnInput"
      @delete="newPasswordOnDelete"
      @blur="newPasswordKeyboard = false"
    />

    <van-number-keyboard
      :z-index="2015"
      :show="confirmPasswordKeyboard"
      @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete"
      @blur="confirmPasswordKeyboard = false"
    />
    <!-- 数字键盘 end -->
    <!-- 修改密码框 end  -->

    <!--  更多套餐信息  -->
    <van-popup
      v-model="pkgListVisible"
      closeable
      position="bottom"
      style="min-height: 35%; max-height: 75%"
    >
      <div class="pkgList">
        <h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
        <h3 v-show="!simInfo.simPackageList[0]" style="color: red">
          当前暂未订购套餐
        </h3>
        <ul>
          <li v-for="item in simInfo.simPackageList" :key="item.id">
            <p>{{ item.packageName }}</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p
                v-if="
                  new Date(
                    getDateByTimeStr(item.endTime)[0],
                    getDateByTimeStr(item.endTime)[1],
                    getDateByTimeStr(item.endTime)[2],
                    getDateByTimeStr(item.endTime)[3],
                    getDateByTimeStr(item.endTime)[4],
                    getDateByTimeStr(item.endTime)[5]
                  ) < new Date()
                "
                style="color: red"
              >
                过期时间： {{ item.endTime }}
              </p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
    <!--  更多套餐信息  end -->

    <!--  智能诊断提醒  -->
    <van-dialog
      v-model="analysisHandlerData.analysisHandlerDialog"
      class="analysisHandlerDialog"
      title="诊断完成"
    >
      <p><span>卡号：</span>{{ recordLoginText }}</p>
      <p>
        <span>当前套餐：</span>
        {{ analysisHandlerData.packageName }}
        <a
          href="javascript: void(0);"
          style="color: #1989fa; float: right"
          @click="showMoreAfterAnalysis()"
          >更 多</a
        >
      </p>
      <p v-show="isShowData">
        <span>剩余流量：</span
        >{{
          fluxMtoG(
            analysisHandlerData.flowRate - analysisHandlerData.usedFlowRate
          )
        }}
        G
      </p>
      <p><span>有效期：</span>{{ analysisHandlerData.endTime }}</p>
      <p><span>状态：</span>{{ analysisHandlerData.simState }}</p>
      <p>
        公众号点击智能诊断，点击更新均可加速复机过程。如果刚充值不满30分钟，请耐心等待即可。
      </p>
    </van-dialog>
    <!--  智能诊断提醒  end  -->
    <keep-alive>
      <SuspendButton @suspendFn="updateStateRateFlow" />
    </keep-alive>

    <!--充值预存送流量的 暂时不要这个功能了-->
    <div class="v-dialog" v-if="1==2"> 
      <div class="v-dialog-bg"></div>
      <div class="v-dialog-content">
        <div class="v-dialog-title">限时优惠</div>
        <div class="v-dialog-small">优惠截止 9.31</div>
        <div class="v-dialog-icon">
          <img src="@/assets/dzp/dialog_title.png" alt="" />
        </div>
        <div class="v-dialog-type">
          <span class="h">预存</span>
          <span>100起 送360G通用流量</span>
        </div>
        <div class="v-dialog-month">（每个月30G）</div>
        <van-button type="info" class="btnButton" @click="viewslink()"
          >立即预存</van-button
        >
        <div class="v-dialog-b">预存款可用于购买后续套餐和服务</div>
        <div class="v-dialog-close">
          <img
            src="@/assets/dzp/dialog_close.png"
            alt=""
            @click="isDialogShow = false"
          />
        </div>
      </div>
    </div>
      <!--推广领卡申请-->
    <div class="v-dialog" v-if="showTui"> 
      <div class="v-dialog-bg"></div>
      <div class="v-dialog-content">
        <div class="v-dialog-title">推广有礼</div>
        <div class="v-dialog-small">无限领取7元余额福利</div>
        <div class="v-dialog-icon">
          <!-- <vue-qr :text="urls" id="urls_id" :size="200"></vue-qr> -->
          <img src="@/assets/dzp/dialog_title7.jpg" alt="" />
        </div>
        <div class="v-dialog-type">
          <span class="h">每推广</span>
          <span>一位用户</span>
          <span class="h">即可免费领取</span>
          <span>7元余额</span>
          <span  class="h">。推广无上限！</span>
        </div>
        <div class="v-dialog-month">（新用户激活后方可领取）</div>
        <!-- 用户点击后 分享给好友。 分享链接为：http://webchat.szxxtx.com/#/user/applygdtdouyingTui   -->
        <van-button type="info" class="btnButton" @click="goshare()"
          >分享好友领取</van-button
        >
        <div class="v-dialog-b">余额可用于购买后续套餐和服务</div>
        <div class="v-dialog-close">
          <img  src="@/assets/dzp/dialog_close.png"  alt=""  @click="showTui = false" />
        </div>
      </div>
    </div>

    <!-- 卡号复制参数 -->
    <div v-show="1 == 2" class="btnOuter" style="background: #26a2ff">
      <mt-button
        style="background: #26a2ff"
        class="tag-read"
        data-clipboard-action="copy"
        :data-clipboard-text="iccid"
        type="primary"
        size="large"
        >点击自动复制卡号，长按二维码实名</mt-button
      >
    </div>

    <!--显示活动弹窗-->
    <div class="v-dialog" v-if="isshowquan">
      <div class="v-dialog-bg"></div>
      <div class="v-dialog-content">
        <div class="v-dialog-title">余额充值</div>
        <div class="v-dialog-small">活动长期有效</div>
        <div class="v-dialog-icon">
          <img src="@/assets/dzp/juan.png" alt="" />
        </div>
        <div class="v-dialog-type">
          <span class="h">预存</span>
          <span>60起 最高可送5张10元叠加券</span>
        </div>
        <div class="v-dialog-month">（叠加券可与赠送金一起使用）</div>
        <van-button type="info" class="btnButton" @click="goQuan()"
          >立即预存</van-button
        >
        <div class="v-dialog-b">预存款可用于购买后续套餐和服务</div>
        <div class="v-dialog-close">
          <img
            src="@/assets/dzp/dialog_close.png"
            alt=""
            @click="isshowquan = false"
          />
        </div>
      </div>
    </div>
    <!-- 图片实名认证 -->
    <van-dialog
      v-show="showimg"
      title="请扫描下方二维码实名"
      show-cancel-button
    >
      <img style="width: 100%" src="@/assets/suolangunicom.jpg" />
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";

import { wxRequest } from "@/api/user.js";
import Clipboard from "clipboard";
import SuspendButton from "@/components/SuspendButton";
import VueQr from 'vue-qr';
import wx from 'weixin-js-sdk';
import { wexinShare } from '@/utils/weixin.js';
export default {
  components: { SuspendButton,VueQr },
  name: "home",
  data() {
    return {
      newHome:localStorage.getItem("newHome"),
      showTui:false,
      urls:"http://webchat.szxxtx.com/#/user/applygdtdouyingTu",
      tuiPrice:0,
      basePkgGroup: localStorage.getItem("basePkgGroup"),
      firstLogin: localStorage.getItem("firstLogin"),
      isshowquan: false,
      showimg: false,
      isCode: localStorage.getItem("isCode"),
      state: "",
      stateName: "",
      wxHeadImg: localStorage.getItem("wxHeadImg"),
      wxNickName: localStorage.getItem("wxNickName"),
      showSupplierTip: false, //
      isDialogShow: false,
      simInfo: {
        simId: "",
        simPackageList: [],
        supplierTypeCode: "",
        packageName: null,
        endTime: null,
      },

      userAccount: {
        amount: 0,
      },
      notifyContent: "现激活设备 可联系客服领取七天免费体验包，更多优惠 请咨询客服！",
      alreadyHasAccount: false,
      canChangeCard: false, //是否可申请换卡

      userInfo: {
        oldIccid: "",
        takeNickname: "",
        takePhone: "",
        takeAddress: "",
        disposeState: "",
        disposeRemark: "",
        changeCmccSim: 6,
        changeCmccSimName: "",
        pcaAddress: "",
      },
      iccid: localStorage.getItem("iccid"),

      //修改密码
      showPasswordPanel: false,

      oldPasswordKeyboard: false,
      newPasswordKeyboard: false,
      confirmPasswordKeyboard: false,

      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordPanelTop: 50,
      //修改密码 end

      pkgListVisible: false,

      //卡片管理弹出层列表
      showIccidList: false,
      iccidList: [],
      refreshIccidList: true,
      defaultIccid: localStorage.getItem("iccid"),

      //智能诊断提醒
      analysisHandlerData: {
        analysisHandlerDialog: false,
        iccid: null,
        packageName: null,
        flowRate: null,
        usedFlowRate: null,
        endTime: null,
        simState: null,
      },
      //判断是否是设备通道
      isShowData: true,

      haveRealName: localStorage.getItem("realNameMsg") != "已实名", //判断电信卡是否已实名认证
      //用户登录输入的iccid/接入号/虚拟
      recordLoginText: null,
    };
  },

  computed: {},
  methods: {
    downloadFile(fileName, content) {
            let aLink = document.createElement('a')
            let blob = this.base64ToBlob(content) // new Blob([content]);
            let evt = document.createEvent('HTMLEvents')
            evt.initEvent('click', true, true)// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName
            aLink.href = URL.createObjectURL(blob)
            // aLink.dispatchEvent(evt);
            aLink.click()
        },
        // base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,')
            let contentType = parts[0].split(':')[1]
            let raw = window.atob(parts[1]) // 解码base64得到二进制字符串
            let rawLength = raw.length
            let uInt8Array = new Uint8Array(rawLength) // 创建8位无符号整数值的类型化数组
            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i) // 数组接收二进制字符串
            }
            return new Blob([uInt8Array], {type: contentType})
        },
    goQuan() {
      this.$router.push({ name: "juanhuodong" });
      this.isshowquan = false;
    },
    toLuckHome() {
      this.$router.push({
        name: "luckDraw",
        query: {
          iccid: this.simInfo.iccid,
        },
      });
    },
     goshare(){
      let iccid = 'http://webchat.szxxtx.com/#/user/applygdtdouyingTui?iccid='+this.recordLoginText;
      // var clipboard = new Clipboard(".tag-read");
          // clipboard.on("success", (e) => {
          //   console.log("复制成功");
          //   clipboard.destroy(); // 释放内存
          // });
          if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
            //ios系统
            window.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
            let inputDom = document.createElement("input");
            document.body.appendChild(inputDom);
            // inputDom.setAttribute("value", iccid);
            // let copyDom=document.getElementById("copyDom");//要复制文字的节点
            // copyDom.appendChild(inputDom);// 把标签添加给body
            // inputDom.style.opacity = 0;//设置input标签设置为透明(不可见)
            inputDom.value = iccid; // 修改文本框的内容
            inputDom.select();
            let range = document.createRange();
            // 选中需要复制的节点
            range.selectNode(inputDom);
            // 执行选中元素
            window.getSelection().addRange(range);
            inputDom.setSelectionRange(0, inputDom.value.length); //适配高版本ios
            // 执行 copy 操作
            document.execCommand("copy");
            // 移除选中的元素
            window.getSelection().removeAllRanges();
            document.body.removeChild(inputDom);
          } else {
            const save = function (e) {
              e.clipboardData.setData("text/plain", iccid);
              e.preventDefault(); // 阻止默认行为
            };
            document.addEventListener("copy", save);
            document.execCommand("copy");
          }
          Dialog.alert({
            title: "分享提示",
            message: "已自动为您复制推广链接，粘贴发给好友即可领取！",
          });
          this.showTui=false;
      
    },
    reloadSim() {
      let data = {
        iccid: this.simInfo.iccid,
      };
      wxRequest("sim/to/reload", data, "get").then((res) => {
        if (res.data.code == 200) {
          Dialog.alert({
            title: "提示",
            message: "刷新成功，请打开飞行模式一下即可",
          });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
    viewslink() {
      this.$router.push({ name: "balanceRechargeApply" });
      this.isDialogShow = false;
    },
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(
        (res) => {
          if (res.data.code == 200) {
            let result = res.data.data;
            localStorage.setItem("supplierCode", result.supplierCode);
            localStorage.setItem("supplierName", result.supplierName);
            localStorage.setItem("supplierTypeCode", result.supplierTypeCode);
            if (result.supplierCode == "1332238069922787328") {
              this.isShowData = false;
            }

            /** 临时提示代码  end  **/

            sessionStorage.setItem("supplierCode", result.supplierCode);
            if (result.cardState && result.cardState == 13) {
              Dialog.alert({
                title: "提示",
                message: "该卡已过期，请重新联系您的经销商购买，谢谢!",
              });
            }

            this.simInfo = result;
            if (
              this.simInfo.basePkgGroup == "1547757996434518016" ||
              this.simInfo.basePkgGroup == "1549295580465852416" ||
               this.simInfo.basePkgGroup == "1587749406130565120" ||
              this.simInfo.basePkgGroup == "1549295498467209216" ||
              this.simInfo.basePkgGroup == "1562613197939142656" ||
              this.simInfo.basePkgGroup == "1565598068475162624" ||
              this.simInfo.basePkgGroup == "1568163178611732480"
            ) {
              this.notifyContent =
                "开户预存活动详情：预存60元得120元，立即到账10元，次月起分11个月每月到账10元。金额自动抵扣每月套餐费，不可抵扣加油包。";
            }

            if (result.simPackageList.length > 1) {
              for (let i = 0; i < result.simPackageList.length; i++) {
                if (
                  result.simPackageList[i].flowRatePercent &&
                  (result.simPackageList[i].flowRatePercent / 100) *
                    result.simPackageList[i].flowRate >
                    result.simPackageList[i].usedFlowRate
                ) {
                  this.simInfo.packageName =
                    result.simPackageList[i].packageName;
                  this.simInfo.endTime = result.simPackageList[i].endTime;
                  break;
                }
              }
            } else if (result.simPackageList.length == 1) {
              this.simInfo.packageName = result.simPackageList[0].packageName;
              this.simInfo.endTime = result.simPackageList[0].endTime;
            }

            this.simInfo.simId = this.simInfo.simPackageList[0]
              ? this.simInfo.simPackageList[0].simId
              : "";

            //画流量仪表盘
            let progressRate = 0;
            if (this.isShowData) {
              progressRate = this.simInfo.usedFlowRate
                ? Math.floor(
                    (this.simInfo.usedFlowRate / this.simInfo.flowRate) * 100
                  )
                : 0;
            } else {
              progressRate = this.simInfo.usedFlowRate
                ? Math.floor(
                    (this.simInfo.usedFlowRate / this.simInfo.usedFlowRate) *
                      100
                  )
                : 0;
            }
            let fz = 40;
            if (progressRate == 100) {
              fz = 30;
            }
            this.drawProgressBar(
              "home_progressBar",
              progressRate,
              3.14,
              "#F89F33",
              ["rgb(25, 137, 250)", "rgb(25, 137, 250)"],
              85,
              fz,
              "inner"
            );
          }
        }
      );
    },

    logoutHandler() {
      localStorage.removeItem("iccid");
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == "true") {
        window.location.href = window.location.origin + "/";
      }
      //若为代理商微信公众号
      else {
        window.location.href =
          window.location.origin + "/?source=" + localStorage.getItem("appid");
      }
    },
    toApplyShop() {
      this.$router.push({
        name: "applyShop",
        query: { iccid: this.simInfo.iccid },
      });
    },
    toApplyTui(){
      this.$router.push({
        name: "applyTui",
        query: { iccid: this.simInfo.iccid },
      });
    },
    toApplyShops() {
      this.$router.push({
        name: "applySalePkg",
        query: { iccid: this.simInfo.iccid },
      });
    },

    toChgCardQuery() {
      /**   换卡判断       **/
      let fd = new FormData();
      let oldIccid = localStorage.getItem("iccid");
      fd.append("iccid", oldIccid);
      wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
        if (res.data.code == "200") {
          let cardType = 0;
          if (res.data.data) {
            cardType = res.data.data.cardType;
          }

          // this.$router.push({
          //   name: "userChgCard",
          //   query: {
          //     oldIccid: oldIccid,
          //     changeCmccSim: 2,
          //   },
          // });
           window.location.href='http://webchat.szxxtx.com/#/user/chgCardQuery';
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });

      /**     换卡判断   end    **/
    },

    toRecharge12() {
      let data = {
        iccid: this.simInfo.iccid,
      };
      Dialog.confirm({
        title: "提示",
        message:
          "请您确保当前卡已完成实名认证并且拥有套餐 方可复机。复机完成后 打开飞行模式一下即可！",
      })
        .then(() => {
          wxRequest("sim/to/active", data, "get").then((res) => {
            Dialog.alert({ title: "提示", message: res.data.message });
          });
        })
        .catch(() => {});
    },
    toRecharge() {
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == "true") {
        let fd = new FormData();
        fd.append("supplierId", sessionStorage.getItem("supplierCode"));
        wxRequest("sim/invent/state", fd, "post").then((res) => {
          if (res.data.code == 200) {
            if (this.userAccount.amount < 0) {
              Dialog.confirm({
                title: "提示",
                message: "您的账户余额已透支，请先充值账户余额！",
              })
                .then(() => {
                  // on confirm
                  this.$router.push({
                    path: "/user/balanceRecharge",
                    query: {
                      iccid: this.$store.state.iccid,
                    },
                  });
                })
                .catch(() => {});
            } else {
              this.$router.push({
                path: "/user/recharge",
                query: {
                  iccid: this.$store.state.iccid,
                },
              });
            }
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
          }
        });
      }

      //若为代理商微信公众号
      else {
        this.$router.push({
          path: "/user/recharge",
          query: {
            iccid: this.$store.state.iccid,
          },
        });
      }
    },

    // 实名判断及移动联通卡判断
    realNameRegister() {
      var simpkg = {
        iccid: this.simInfo.iccid,
      };
      let iccid = this.simInfo.iccid;
      wxRequest("bindPhone/sim/pkg", simpkg, "post").then((res) => {
        if (res.data.code != 200) {
          Dialog.alert({ title: "提示", message: res.data.message });
        } else {
          if (
            this.simInfo.supplierTypeCode == 1 ||
            this.simInfo.supplierTypeCode == 5
          ) {
            Dialog.confirm({
              title: "实名提示",
              message:
                "请复制此ICCID：" +
                this.simInfo.iccid +
                "，点击确认 去完成实名",
            })
              .then(() => {
                window.location.href =
                  "http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504";
              })
              .catch(() => {});
          } else if (this.simInfo.supplierTypeCode == 3) {
            //移动
                            let data = {
                              iccid: localStorage.getItem("iccid"),
                            };
                            wxRequest("sim/get/cmcc/auth", data, "get").then(
                              (res) => {
                                if (res.data.code == 200) {
                                  window.location.href = res.data.data;
                                } else {
                                  Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                  });
                                }
                              }
                            );
          } else {
            this.$router.push({
                  path: "/user/cuccToAuth",
                  query: {
                    state: this.state,
                    supplierTypeCode: this.simInfo.supplierTypeCode,
                  },
                });

          }
        }
      });
    },

    toBalanceRecharge() {
      let fd = new FormData();
      fd.append("supplierId", sessionStorage.getItem("supplierCode"));
      wxRequest("sim/invent/state", fd, "post").then((res) => {
        if (res.data.code == 200) {
          this.$router.push({
            path: "/user/balanceRecharge",
            query: {
              iccid: this.$store.state.iccid,
            },
          });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    getAccount() {
      let param = {
        iccid: this.$store.state.iccid,
        mobile: localStorage.getItem("mobile"),
      };
      localStorage.setItem('userSimAmount',0)
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == "true") {
        wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
          (res) => {
            if (res.data.code == 200) {
              this.userAccount = res.data.data;
              localStorage.setItem('userSimAmount',this.userAccount.amount)
              this.alreadyHasAccount = true;
            } else if (res.data.code == 400) {
              let self = this;
              if (self.$store.state.supplierCode == "1197749413972275200") {
                Dialog.confirm({
                  title: "提示",
                  message: "首次使用需进行充值，请点击【确认】前往充值",
                })
                  .then(() => {
                    // on confirm
                    self.$router.push({
                      path: "/user/cardSetUp",
                      query: {
                        iccid: self.$store.state.iccid,
                      },
                    });
                  })
                  .catch(() => {});
              }
            }
          }
        );
      }

      //若为代理商公众号
      else {
        wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
          (res) => {
            if (res.data.code == 200) {
              this.userAccount = res.data.data;
              this.alreadyHasAccount = true;
            }
          }
        );
      }
    },

    //跳往更多公告页面
    toMoreNotify() {
      this.$router.push({
        path: "/user/notify",
      });
    },

    //一键智能诊断
    analysisHandler() {
      let _this = this;
      let data = new FormData();
      data.append("iccid", this.$store.state.iccid);

      //应后端要求  两次请求
      wxRequest("sim/update/stateRateFlow", data, "post").then((res) => {
        wxRequest("sim/select/stateRateFlow/info", data, "post").then(
          (newRes) => {
            if (newRes.data.code == 200) {
              let resultList = newRes.data.data.simPkg;
              if (resultList.length > 1) {
                for (let i = 0; i < resultList.length; i++) {
                  if (
                    resultList[i].flowRatePercent &&
                    (resultList[i].flowRatePercent / 100) *
                      resultList[i].flowRate >
                      resultList[i].usedFlowRate
                  ) {
                    for (let key in this.analysisHandlerData) {
                      this.analysisHandlerData[key] = resultList[i][key];
                    }
                    break;
                  }
                }
              } else if (resultList.length == 1) {
                for (let key in this.analysisHandlerData) {
                  this.analysisHandlerData[key] = resultList[0][key];
                }
              }
              this.analysisHandlerData.simState = newRes.data.data.simState;
              this.analysisHandlerData.analysisHandlerDialog = true;
              this.getUserSimInfo();
            } else {
              Dialog.alert({ title: "提示", message: newRes.data.message });
            }
          }
        );
      });
    },

    showMoreAfterAnalysis() {
      this.analysisHandlerData.analysisHandlerDialog = false;
      this.pkgListVisible = true;
    },

    // 更新状态、流量比
    updateStateRateFlow(isSingleTouch) {
      if (isSingleTouch) {
        let fd = new FormData();
        fd.append("iccid", this.$store.state.iccid);
        wxRequest("sim/select/stateRateFlow", fd, "post").then((res) => {
          this.getUserSimInfo();
        });
      }
    },

    //机卡重绑
    reBind() {
      Dialog.confirm({
        message: "机卡重绑每个月仅有两次机会，请不要更换设备使用，确定重绑吗？",
        className: "reBindColor",
      })
        .then(() => {
          let param = {
            intoNo: this.simInfo.intoNo,
            supplierCode: this.simInfo.supplierCode,
          };
          wxRequest("sim/unbind", param, "post").then((res) => {
            if (res.data.message) {
              Dialog.alert({ title: "提示", message: res.data.message });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    //获取绑定的卡片列表
    getBindIccidListHandler() {
      var data = {
        userPhone: localStorage.getItem("mobile"),
      };
      wxRequest("bindPhone/list", data, "post").then((res) => {
        if (res.data.code == 200) {
          this.refreshIccidList = false;
          this.$nextTick(() => {
            this.refreshIccidList = true;
            this.iccidList = res.data.data;
          });
        }
      });
    },

    //卡片管理
    deleteBindIccidHandler(iccid) {
      Dialog.confirm({ message: "您确定删除吗？" })
        .then((action) => {
          var data = {
            iccid,
            userPhone: localStorage.getItem("mobile"),
          };
          wxRequest("bindPhone/delete", data, "post").then((res) => {
            if (res.data.code == 200) {
              Toast.success("删除成功");
              if (res.data.data == null || res.data.data.length == 0) {
                window.location.href = window.location.origin + "#/user";
              } else {
                this.getBindIccidListHandler();
                this.showIccidList = false;
              }
            } else {
              Dialog.alert({ title: "提示", message: res.data.message });
            }
          });
        })
        .catch(() => {});
    },
    updateDefaultBindIccidHandler(iccid) {
      var data = {
        iccid: this.defaultIccid,
        defaultIccid: iccid,
      };
      wxRequest("bindPhone/update/default", data, "post").then((res) => {
        if (res.data.code == 200) {
          Dialog.alert({
            title: "提示",
            message: "设置成功，将会退出重新登录",
          }).then(() => {
            localStorage.setItem("iccid", iccid);
            window.location.href = window.location.origin + "/";
          });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    /***   修改密码     ***/
    oldPasswordOnfocus() {
      this.oldPasswordKeyboard = true;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    oldPasswordOnDelete() {
      this.oldPassword = this.oldPassword.slice(0, this.oldPassword.length - 1);
    },

    oldPasswordOnInput(key) {
      this.oldPassword = (this.oldPassword + key).slice(0, 6);
    },

    newPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    newPasswordOnDelete() {
      this.newPassword = this.newPassword.slice(0, this.newPassword.length - 1);
    },

    newPasswordOnInput(key) {
      this.newPassword = (this.newPassword + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(
        0,
        this.confirmPassword.length - 1
      );
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    sureToChangePassword() {
      if (
        this.oldPassword.length < 6 ||
        this.newPassword.length < 6 ||
        this.confirmPassword.length < 6
      ) {
        Dialog.alert({ message: "请输入六位密码" });
        return;
      }

      if (this.newPassword != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return;
      }

      let data = {
        iccid: this.$store.state.iccid,
        paypassOld: this.oldPassword,
        paypass: this.confirmPassword,
      };
      wxRequest("sysUser/account/user/resetPaypass", data, "post").then(
        (res) => {
          if (res.data.code == 200) {
            Toast.success(res.data.message);
            this.cancelChangePassword();
          } else {
            Dialog.alert({ message: res.data.message });
          }
        }
      );
    },
    /***   修改密码  end   ***/

    getDateByTimeStr(timeStr) {
      if (timeStr && typeof timeStr === "string") {
        let dayStr = timeStr.split(" ")[0].split("-");
        let hourStr = timeStr.split(" ")[1].split(":");
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },
    confirmMobile() {
      if ("localStorage.getItem('realNameMsg') == '已实名'") {
        this.$router.push({
          path: "/cancelRealName",
        });
      } else {
        Dialog.alert({ message: "您未进行过实名" });
      }
    },
     goshare1() {
      const jsApiList=[
		    'checkJsApi', //检测接口权限	
			  'updateTimelineShareData',
			  'updateAppMessageShareData',
			  'onMenuShareAppMessage', //老版本分享接口(注意这两个旧版本的必须要放的不然会有问题)
			  'onMenuShareTimeline' //老版本分享接口。
			]
      this.urls =  'http://webchat.szxxtx.com/#/user/applygdtdouyingTui?iccid='+this.recordLoginText;
      wxRequest("sim/getWxConfig3", {}, "get").then(res => {
        if (res.data.code == 200) {
          console.log(res.data.data)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名
            jsApiList
          });
          let that = this;
           // 判断客户端是否支持指定js的接口
          
          wx.error((res) => {//配置成功
            for (var msg in res) {
              let obj = {
                showAlert: true,
                errTitle: "错误提示",
                errMsg: JSON.stringify(res[msg]),
                errCode: ""
              }
            }
          })
          //以上是配置项注入成功
          wx.ready(() => {//点击要去分享
            // this.share(shareData);
            wx.checkJsApi({
              jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              }
            });
            wx.updateTimelineShareData({//配置去分享朋友圈的选项
              title: '移动100G流量免费领！',//分享标题
              link: this.urls, //分享链接
              imgUrl: 'http://webchat.szxxtx.com:8888/group1/M00/00/00/rBi58mPrSReADaCoAAZSmADPths189.png', //分享图标
              success: function (res) {//分享成功 
              },
              cancel: function () {
              }
            })
            wx.onMenuShareAppMessage({
              title:'324234234移动100G流量免费领！', // 分享标题
              desc: '点击此链接即可免费领取 包邮到家！', // 分享描述
              link: this.urls,
              imgUrl: 'http://webchat.szxxtx.com:8888/group1/M00/00/00/rBi58mPrSReADaCoAAZSmADPths189.png', //分享图标 
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
              }
            })
            wx.onMenuShareTimeline({
              title: '移动100G流量免费领！',//分享标题
              link: this.urls, //分享链接
              imgUrl: 'http://webchat.szxxtx.com:8888/group1/M00/00/00/rBi58mPrSReADaCoAAZSmADPths189.png', //分享图标
              success: function (res) {//分享成功 
                //如分享成功后想做一些其他的业务处理，可以在这里做
              },
              cancel: function () {
                //that.alert="失败弹框话术等等(注意 这里拿不到this实例的)"
              }
            })
            wx.updateAppMessageShareData({//配置去分享好友的选项
              title: '移动100G流量免费领！',
              link: this.urls,
              desc: '点击此链接即可免费领取 包邮到家！',
              imgUrl: 'http://webchat.szxxtx.com:8888/group1/M00/00/00/rBi58mPrSReADaCoAAZSmADPths189.png', //分享图标          
              success: function (res) {
              },
              cancel: function (res) {
              }
            });
          })
        }
        //分享给朋友
      })
    },
  },
  async created() {
    
    if(this.newHome==1){
      //  this.$router.push({
      //                         path: "/newUser/home"
      //                       });
      //                       return;
    }
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));
    this.recordLoginText = localStorage.getItem("recordLoginText");
    this.urls = "http://webchat.szxxtx.com/#/user/applygdtdouyingTui?iccid=" + this.recordLoginText;//分享链接
    this.$store.state.recordLoginText = localStorage.getItem("recordLoginText");
    var data = {
      iccid: this.$store.state.iccid,
    };
   // this.goshare1();
    wxRequest("wxAuth/state", data, "post").then((res) => {
      if (res.data.code == 200) {
        if (res.data.data.supplierCode == "B1E112B9F1D8420E9072D9F47D6A135E") {
          this.showSupplierTip = true;
        } else {
          this.showSupplierTip = false;
        }
        var result = res.data.data;
        this.state = result.authState;
        this.stateName = result.authStateNick;
      }
    });

    //获取绑定的卡片列表
    this.getBindIccidListHandler();

    //获取首条公告
    wxRequest("sim/notice/top", fd, "post").then((res) => {
      if (res.data.code == "200") {
        this.notifyContent = res.data.data.content;
      }
    });
  },

  async mounted() {

     if(this.newHome==1){
      //  this.$router.push({
      //                         path: "/newUser/home"
      //                       });
      //                       return;
    }
    this.tuiPrice = localStorage.getItem('tuiPrice')
    /**   换卡判断       **/
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));
    // if(this.$store.state.isHeadquarterAppid=='true'){
    wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
      if (res.data.code == "200") {
        this.canChangeCard = true;
        let cardType = 0;
        let cardTypeStr = "电信";
        if (res.data.data) {
          cardType = res.data.data.cardType;
          cardTypeStr = res.data.data.cardType == 0 ? "移动" : res.data.data.cardType == 1 ? "电信"  : "联通";
        }
        //公司本部公众号
        if (localStorage.getItem("isHeadquarterAppid") == "true") {
          Dialog.alert({
            title: "提示",
            messageAlign: "left",
            message:
              "尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，我司将免费给您更换网速良好的新卡使用，请填写好您的联系方式和地址，原卡套餐流量将会转移到新卡，感谢您一直以来的支持 ！",
          }).then((action) => {
            let cardBeLack = "移动";
            if (cardTypeStr == "移动") {
              cardBeLack = "电信";
            }
            Dialog.confirm({
              title: "提示",
              message:
                "目前移动卡充足，" +
                "其他卡缺货(发货时间可能较长)，您确定要换卡吗？",
            })
              .then((action) => {
                if (action == "confirm") {
                  // this.$router.push({
                  //   name: "userChgCard",
                  //   query: {
                  //     oldIccid: localStorage.getItem("iccid"),
                  //     changeCmccSim: cardType,
                  //   },
                  // });
                  window.location.href='http://webchat.szxxtx.com/#/user/chgCardQuery';
                }
              })
              .catch(() => {});
          });
        } else {
          Dialog.alert({
            title: "提示",
            messageAlign: "left",
            message:
              "尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，请联系您的经销商，谢谢！",
          });
        }
      } else if (
        this.basePkgGroup == "1562613197939142656" ||
        this.basePkgGroup == "1565598068475162624"
      ) {
        let iccid = localStorage.getItem("iccid");
        wxRequest("sim/is/have/pkgs", { iccid: iccid }, "get").then((res) => {
          let types = res.data.data;
          if (res.data.code == 200) {
            wxRequest("wxAuth/supplierAuth", { iccid: iccid }, "post").then(
              (res) => {
                if (res.data.code != 200) {
                  if (types == 49) {
                     this.$router.push({
                  path: "/user/cuccToAuth",
                  query: {
                    state: this.state,
                    supplierTypeCode: this.simInfo.supplierTypeCode,
                  },
                });
                  } else {
                    Dialog.confirm({
                      title: "实名提示",
                      message:
                        "尊敬的用户，流量卡必须完成实名后 方可正常使用，请点击 确定 前往实名，如已实名请忽略",
                    })
                      .then((action) => {
                        if (action == "confirm") {
                          if (types == 49) {
                            this.$router.push({
                              path: "/user/cuccToAuth",
                              query: {
                                state: this.state,
                                supplierTypeCode: 49,
                              },
                            });
                          } else if (types == 3) {
                            //移动
                            let data = {
                              iccid: localStorage.getItem("iccid"),
                            };
                            wxRequest("sim/get/cmcc/auth", data, "get").then(
                              (res) => {
                                if (res.data.code == 200) {
                                  window.location.href = res.data.data;
                                } else {
                                  Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                  });
                                }
                              }
                            );
                          } else {
                            window.location.href =
                              "http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504";
                          }
                        }
                      })
                      .catch(() => {});
                  }
                } else if( localStorage.getItem("iccid")=='88888888885555544444') {
                  this.showTui=true;
                }
              }
            );
          } else {
            Dialog.confirm({
              title: "温馨提醒",
              message:
                "您已成功参与充80得240赠送活动,首月可使用免费券进行0元购。点击确定前往兑换激活!",
            }).then((action) => {
              if (action == "confirm") {
                this.$router.replace("/user/recharge");
              }
            });
          }
        });
      } else {
        var datas = {
          iccid: localStorage.getItem("iccid"),
        };
        let iccid = localStorage.getItem("iccid"); //需要复制的值
        wxRequest("sim/is/have/pkgs", { iccid: iccid }, "get").then((res) => {
          let types = res.data.data;
          if (res.data.code == 200) {
            let _data = { iccid: iccid };
            wxRequest("wxAuth/supplierAuth", _data, "post").then((res) => {
              if( localStorage.getItem("iccid")=='88888888885555544444') {
                    this.showTui=true;
              }else if (res.data.code != 200) {
                if (types == 49) {
                  //  Dialog.confirm({
                  //     title: "实名提示",
                  //     message:
                  //       "已自动复制实名卡号！卡号为：" +
                  //       iccid +
                  //       "，点击确定去完成实名后，方可正常激活使用。如已实名 请忽略",
                  //   })
                  //     .then((action) => {
                  //       Toast.fail("卡号复制成功");
                  //       if (action == "confirm") {
                  //         // var clipboard = new Clipboard(".tag-read");
                  //         // clipboard.on("success", (e) => {
                  //         //   console.log("复制成功");
                  //         //   clipboard.destroy(); // 释放内存
                  //         // });
                  //         if (
                  //           navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)
                  //         ) {
                  //           //ios系统
                  //           window.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
                  //           let inputDom = document.createElement("input");
                  //           document.body.appendChild(inputDom);
                  //           // inputDom.setAttribute("value", iccid);
                  //           // let copyDom=document.getElementById("copyDom");//要复制文字的节点
                  //           // copyDom.appendChild(inputDom);// 把标签添加给body
                  //           // inputDom.style.opacity = 0;//设置input标签设置为透明(不可见)
                  //           inputDom.value = iccid; // 修改文本框的内容
                  //           inputDom.select();
                  //           let range = document.createRange();
                  //           // 选中需要复制的节点
                  //           range.selectNode(inputDom);
                  //           // 执行选中元素
                  //           window.getSelection().addRange(range);
                  //           inputDom.setSelectionRange(
                  //             0,
                  //             inputDom.value.length
                  //           ); //适配高版本ios
                  //           // 执行 copy 操作
                  //           document.execCommand("copy");
                  //           // 移除选中的元素
                  //           window.getSelection().removeAllRanges();
                  //           document.body.removeChild(inputDom);
                  //         } else {
                  //           const save = function (e) {
                  //             e.clipboardData.setData("text/plain", iccid);
                  //             e.preventDefault(); // 阻止默认行为
                  //           };
                  //           document.addEventListener("copy", save);
                  //           document.execCommand("copy");
                  //         }
                  //         window.location.href =
                  //           "https://env-9gk22lag4fab0241-1309553396.tcloudbaseapp.com/jump-mp.html";
                  //       }
                  //     })
                  //     .catch(() => {});
                  this.$router.push({
                  path: "/user/cuccToAuth",
                  query: {
                    state: this.state,
                    supplierTypeCode: this.simInfo.supplierTypeCode,
                  },
                });
                } else {
                  Dialog.confirm({
                    title: "实名提示",
                    message:
                      "尊敬的用户，流量卡必须完成实名后 方可正常使用，请点击 确定 前往实名，如已实名请忽略",
                  })
                    .then((action) => {
                      if (action == "confirm") {
                        if (types == 49) {
                          this.$router.push({
                            path: "/user/cuccToAuth",
                            query: {
                              state: this.state,
                              supplierTypeCode: 49,
                            },
                          });
                        } else if (types == 3) {
                          //移动
                          let data = {
                            iccid: localStorage.getItem("iccid"),
                          };
                          wxRequest("sim/get/cmcc/auth", data, "get").then(
                            (res) => {
                              if (res.data.code == 200) {
                                window.location.href = res.data.data;
                              } else {
                                Dialog.alert({
                                  title: "提示",
                                  message: res.data.message,
                                });
                              }
                            }
                          );
                        } else {
                          window.location.href =
                            "http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504";
                        }
                      }
                    })
                    .catch(() => {});
                }
              } else if( localStorage.getItem("iccid")=='88888888885555544444') {
                  this.showTui=true;
                }
            });
          } else if (
            this.basePkgGroup == "1549295580465852416" ||
              this.basePkgGroup == "1587749406130565120" ||
            this.basePkgGroup == "1549295498467209216" ||
            this.basePkgGroup == "1568163178611732480"
          ) {
            Dialog.confirm({
              title: "温馨提醒",
              message:
                "您已成功参与充60得120赠送活动。每月套餐自动减免10元！请购买套餐正常使用。",
            }).then((action) => {
              if (action == "confirm") {
                this.$router.replace("/user/recharge");
              }
            });
          }
          else if (
            this.basePkgGroup == "1588080292403343360" 
          ) {
            Dialog.confirm({
              title: "温馨提醒",
              message:
                "您已成功参与充100得480优惠券活动。每月套餐券后最低可至9.9元100G！请点击确定 去购买套餐正常使用。",
            }).then((action) => {
              if (action == "confirm") {
                this.$router.replace("/user/recharge");
              }
            });
          } else if (
            this.basePkgGroup == "1595609837910093824" ||this.basePkgGroup == "1595609014362697728"||this.basePkgGroup == "1597081108845948928" ||this.basePkgGroup == "1620242289261539328" 
          ) {
            Dialog.confirm({
              title: "温馨提醒",
              message:
                "您已成功参与充购买优惠券活动。每月套餐可使用优惠券抵扣套餐金额！请点击确定 去购买套餐正常使用。",
            }).then((action) => {
              if (action == "confirm") {
                this.$router.replace("/user/recharge");
              }
            });
          }
        });
      }
    });
    // }

    /**     换卡判断   end    **/

    this.getUserSimInfo();
    this.getAccount();
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == "/user") {
      window.location.href = window.location.origin + "#/user";
    }
    next();
  },
};
</script>



<style lang="less" >
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#home_progressBar {
  position: absolute;
  width: 14.5rem;
  height: 14.5rem;
  top: -25px;
  left: calc(50% - 7.25rem);
}

.v-dialog {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  .v-dialog-bg {
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }
  .v-dialog-close {
    width: 22px;
    height: 22px;
    // margin:0 auto;
    // margin-top:20px;
    position: absolute;
    bottom: -50px;
    left: 0;
    right: 0;
    margin: auto;
    img {
      height: 100%;
      cursor: pointer;
    }
  }
  .v-dialog-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 255px;
    height: 353px;
    background: url("../../assets/dzp/dialog_bg.png") no-repeat center;
    background-size: 100% 100%;
    z-index: 11;
    .v-dialog-title {
      width: 100px;
      height: 23px;
      font-size: 23px;
      font-family: STJTBZITALICUNICODE;
      color: #ffffff;
      line-height: 23px;
      font-style: oblique;
      letter-spacing: 2px;
      margin-left: 25px;
      margin-top: 29px;
    }
    .v-dialog-small {
      font-size: 12px;
      margin-left: 25px;
      color: #fff;
      line-height: 16px;
      margin-top: 4px;
    }
    .v-dialog-icon {
      width: 66px;
      height: 68px;
      margin: 0 auto;
      margin-top: 36px;
      img {
        height: 100%;
      }
    }
    .v-dialog-type {
      font-size: 18px;
      color: #ff4e00;
      padding: 11px 15px 5px;
      .h {
        color: #4a4a4a;
      }
    }
    .v-dialog-month {
      font-size: 14px;
      color: #a6a6a6;
      padding-top: 4px;
      width: 196px;
      margin: 0 auto;
      text-align: center;
    }
    .btnButton {
      width: 70%;
      margin: 16px auto;
      margin-top: 20px;
      font-size: 16px;
      display: block;
      border-radius: 22px;
      background: -webkit-linear-gradient(
        to bottom,
        #ffd73f,
        #ff4e00
      ); /* Safari 5.1-6.0 */
      background: -o-linear-gradient(
        to bottom,
        #ffd73f,
        #ff4e00
      ); /* Opera 11.1-12.0 */
      background: -moz-linear-gradient(
        to bottom,
        #ffd73f,
        #ff4e00
      ); /* Firefox 3.6-15 */
      background: linear-gradient(to bottom, #ffd73f, #ff4e00); /* 标准语法 */
      border: 1px solid #ff4e00;
      border-top-color: #ffd73f;
      border-left-color: #ffd73f;
      border-right-color: #ffd73f;
    }
    .v-dialog-b {
      margin-top: 14px;
      color: #ff4e00;
      font-size: 14px;
      text-align: center;
    }
  }
}
#home {
  height: 100%;
  background: rgba(246, 246, 246, 1);

  a {
    color: #2c3e50;
  }
  .home-top {
    color: #fff;
    height: 45%;
    background-image: linear-gradient(#ffd476, #ffa941);
    background-size: 100% 100%;
    .yue{
      padding:10px;
      background:#fff;
      border-radius:7px;
      width:130px;
      font-size:16px;
      position: relative;
      z-index:10;
      margin:8px auto 0px;
    }
    .header {
      display: flex;
      padding: 20px;
      padding-bottom: 5px;

      .logo,
      .header-userInfo {
        display: inline-block;
      }

      .logo {
        margin-right: 20px;
        img {
          width: 65px;
          height: 65px;
          margin-bottom: 10px;
          border-radius: 35px;
          border: 2px solid #fff;
        }
      }
      .header-userInfo {
        width: 100%;
        p {
          line-height: 24px;
          font-size: 16px;
        }
        > div {
          display: flex;
          p {
            flex: 1;
          }
          p:last-child {
            text-align: right;
          }
        }

        .iccid-line {
          display: flex;
          align-items: center;
          div,
          p {
            display: inline-block;
            vertical-align: middle;
            text-align: left !important;
          }
          div {
            display: block;
            margin-left: 3px;
          }
        }
        .u-flex {
          display: flex;
          align-items: center;
          .freshBtn {
            display: flex;
            position: relative;
            width: 30px;
            height: 24px;
            padding: 10px;
            border: none;
            img {
              position: absolute;
              top: 2px;
              left: 3px;
              width: 20px;
              height: 18px;
            }
          }
        }
      }
    }
  }

  .flowInfo {
    position: relative;
    text-align: center;

    .residue-flow {
      padding-top: 10px;
      p:first-child {
        padding-top: 30px;
        font-size: 38px;
      }
      p:last-child {
        line-height: 18px;
      }
    }

    .flowInfo-bottom {
      display: flex;
      margin-top: 0px;

      .total-flow {
        p:first-child {
          font-size: 24px;
        }
        flex: 1;
      }
      .used-flow {
        p:first-child {
          font-size: 24px;
        }
        flex: 1;
      }
    }
  }

  .iccid-list {
    padding: 30px 15px 10px;
    box-sizing: border-box;

    h1 {
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
    }

    .iccid-list-item {
      box-sizing: border-box;
      height: 45px;
      display: flex;
      margin-bottom: 2px;
      border-bottom: 1px solid #f7f7f7;

      p {
        flex: 1;
        line-height: 45px;
        color: #000;
      }

      button {
        margin: 2px 0 0 5px;
        height: 40px;
        width: 70px;
        color: #909399;
        background: #f4f4f5;
        border: 1px solid #d3d4d6;
        border-radius: 5px;
      }

      .delete-item {
        color: #f56c6c;
        background: #fef0f0;
        border: 1px solid #fbc4c4;
        border-radius: 5px;
      }
    }

    .iccid-list-item:last-child {
    }
  }

  .main {
    position: absolute;
    top: 250px;
    left: 0;

    .content-top {
      width: 100%;
      padding: 20px 20px;
      padding-bottom: 0;
      .main-top {
        padding: 5px 10px;
        margin-bottom: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgb(218, 218, 218);
        border-radius: 5px;

        .first-line {
          flex-wrap: wrap;

          p.packageName {
            width: calc(100% - 40px);
            a {
              color: rgb(25, 137, 250);
            }
          }

          p.morePackage {
            max-width: 40px;
            text-align: right;
            a {
              color: rgb(25, 137, 250);
            }
          }

          p.time-line {
            flex-wrap: 4;
            line-height: 24px;
          }
        }

        .line {
          display: flex;
          margin: 0;
          padding: 0 0 5px 0;
          font-size: 0.8rem;

          p {
            margin: 0;
            height: 28px;
            line-height: 28px;
          }

          > div {
            display: flex;
            flex: 0;
            flex-direction: row-reverse;

            span {
              display: flex;
              height: 24px;
              line-height: 24px;
              text-align: right;
              max-width: 200px;
              color: #ffa941;
              font-weight: bold;
              margin-right: 5px;
            }
            .rechargeBtn {
              width: 50px;
              height: 28px;
              margin-left: 10px;
              color: #fff;
              border-radius: 3px;
              border: none;
              background: #ffaa43;
            }
          }

          .p-sim {
            width: 100%;
            line-height: 28px;
          }
        }
      }
    }

    .content-bottom {
      width: 100%;
      padding: 20px 20px;
      padding-top: 0;
      background: rgba(246, 246, 246, 1);

      .main-bottom {
        padding: 0 0 25px 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgb(218, 218, 218);
        border-radius: 3px;

        > div {
          display: flex;
          flex-wrap: wrap;

          > div {
            width: 25%;
            display: flex;
            margin-top: 25px;
            text-align: center;

            > a {
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 46%;
              }
              > div {
                width: 20%;
                height: 1px;
                box-shadow: 0 4px 5px rgba(0, 78, 156, 0.8);
                margin-bottom: 12px;
              }
              span {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

  .tip {
    line-height: 24px;
    margin: 0 20px;
    padding: 10px;
    color: #c34e4e;
    background: #ffe1e1;
    border-radius: 5px;
    text-align: center;
  }

  .footer {
    display: flex;
    height: 26%;
    padding: 0 10%;
    align-items: center;
    justify-content: center;
  }

  .pkgList {
    padding: 10px 20px;

    h3 {
      margin-top: 20px;
      font-size: 14px;
      line-height: 28px;
      font-weight: bold;
    }

    ul {
      line-height: 38px;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        > p {
          display: flex;
          align-items: center;
        }
        > div {
          p {
            line-height: 18px;
            font-size: 12px;
          }
        }
      }
    }
  }
}

.red-defind {
  color: #cc2b2b;
}

.green-defind {
  color: green;
}

.changePasswordPanel {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}

.home-advertisement {
  margin-top: 100px;
}

.analysisHandlerDialog {
  p {
    font-size: 0.9rem;
    line-height: 1.5rem;
    padding: 0 1rem;

    span {
      font-weight: bold;
    }

    a:after {
      display: block;
      content: "clear";
      height: 0;
      clear: both;
      overflow: hidden;
      visibility: hidden;
    }
  }

  p:first-child {
    padding-top: 0.5rem;
  }
}
</style>

<style>
.changePasswordPanel [class*="van-hairline"]::after {
  border-color: #c4cedc;
}
/* 重绑机卡弹出框提示的颜色 */
.reBindColor {
  color: #f76161;
}
</style>